var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"stringItem regular-13",style:(_vm.styleOptions + _vm.clickStyle),attrs:{"title":_vm.formattedItem},domProps:{"textContent":_vm._s(_vm.formattedItem)},on:{"click":_vm.emitId}})
}
var staticRenderFns = []

export { render, staticRenderFns }